/* eslint-disable no-empty-function */
import CustomStore from 'devextreme/data/custom_store';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '~/services/api';
import { handleError, handleParams } from '~/services/helper';
import store from '~/store/Store';

export async function handleRegisterSubMenu(subMenu, setLoading) {
  await api
    .post('MenuSub', subMenu)
    .then(() => {
      setLoading(false);
      toast.success('Sub menu criado com sucesso');
    })
    .catch(() => {
      toast.error(
        'Erro ao criar sub menu, verifique os dados e tente novamente'
      );
      setLoading(false);
    });
}

export async function handeGetMenusData(
  e,
  setLoading,
  setMenus,
  setModuloSelected,
  setMenuSelected
) {
  e.preventDefault();
  setMenuSelected(false);
  const moduloID = store.getState().SubMenu.idModuloSubMenu;
  setLoading(true);

  if (moduloID === 0) {
    toast.error('Escolha um módulo');
    setLoading(false);
    return;
  }

  await api
    .get(`/Menu/GetPaginado/Modulo/${moduloID}/Page/1/Length/1000`)
    .then((response) => {
      const { registros, totalRegistros } = response.data;
      if (totalRegistros === 0) {
        toast.error('Módulo selecionado não possui menus');
        setLoading(false);
        setModuloSelected(false);
        return;
      }
      setMenus(registros);
      setLoading(false);
      setModuloSelected(true);
    })
    .catch(() => {
      toast.error('Algo deu errado ao buscar as páginas, tente novamente');
      setLoading(false);
    });
}

export async function handleGetSubMenus(
  setLoading,
  setParents,
  setMenuSelected
) {
  setLoading(true);
  const menuID = store.getState().SubMenu.idMenuSubMenu;
  if (menuID === 0) {
    toast.error('Escolha um menu');
    setLoading(false);
    return;
  }

  await api
    .get(`/MenuSub/GetPaginado/Menu/${menuID}/Page/1/Length/1000`)
    .then((response) => {
      const { registros } = response.data;
      setParents(registros);
      setLoading(false);
      setMenuSelected(true);
    })
    .catch(() => {
      toast.error('Algo deu errado ao buscar as páginas, tente novamente');
      setLoading(false);
    });
}

export async function handleDeleteSubMenu(setLoading) {
  setLoading(true);
  toast.info('Excluindo sub menu ...');
  const subMenuID = store.getState().SubMenu.idSubMenu;
  await api
    .delete(`/MenuSub?pId=${subMenuID}`)
    .then(() => {
      toast.success('Sub menu excluido com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error(
        'Erro ao excluir o Sub menu, atualize a página e tente novamente'
      );
    });
}

export async function handleUpdateSubMenu(subMenu, setLoading) {
  await api
    .put('/MenuSub', subMenu)
    .then(() => {
      setLoading(false);
      toast.success('Dados do sub menu atualizados com sucesso');
    })
    .catch(() => {
      toast.error('Erro ao atualizar dados, tente novamente');
      setLoading(false);
    });
}

function handleLoadSubMenuData(loadOptions) {
  const menuID = store.getState().SubMenu.idMenuSubMenu;
  const params = {
    idMenu: menuID,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/MenuSub?${qs.stringify(newParams)}`;
  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => {
      handleError('Erro ao carregar', err);
    });
}

async function handleRemoveSubMenu(key) {
  const url = `MenuSub?pId=${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Sub Menu deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridSubMenuDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadSubMenuData(loadOptions),
    remove: (key) => handleRemoveSubMenu(key),
  }),
};
